import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Loader2, ArrowLeft, Lock } from 'lucide-react';
import { employeeApi, errMsg } from '../api';
import { WorkforceAuthPage, WorkforceHero, PasswordInput } from '../WorkforceTheme';

export default function EmployeeLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError('');
    try {
      const r = await employeeApi.login(email, password);
      localStorage.setItem('employee_token', r.data.token);
      navigate('/workforce/home');
    } catch (err) {
      setError(errMsg(err, 'Login failed'));
    } finally { setBusy(false); }
  };

  return (
    <WorkforceAuthPage showStrip={false}>
      <div className="w-full max-w-2xl">
        <WorkforceHero subtitle="Sign in to clock in, track your hours, and view your pay." />
        <form onSubmit={submit} className="w-full max-w-sm mx-auto rounded-2xl border border-[#D4AF37]/25 bg-black/60 backdrop-blur-md p-6 space-y-4 shadow-[0_0_60px_rgba(212,175,55,0.08)]" data-testid="workforce-login-form">
          <div className="flex items-center gap-2">
            <span className="h-8 w-8 rounded-full border border-[#D4AF37]/60 flex items-center justify-center"><Lock size={14} className="text-[#D4AF37]" /></span>
            <h1 className="text-white font-brand font-extrabold text-lg">Sign In</h1>
          </div>
          <div>
            <label className="text-xs text-gray-400 block mb-1.5">Email</label>
            <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} autoCapitalize="none" placeholder="you@example.com" className="bg-black/60 border-gray-700 text-white" data-testid="workforce-email" />
          </div>
          <div>
            <label className="text-xs text-gray-400 block mb-1.5">Password</label>
            <PasswordInput value={password} onChange={(e) => setPassword(e.target.value)} testId="workforce-password" />
          </div>
          {error && <p className="text-red-400 text-sm" data-testid="workforce-login-error">{error}</p>}
          <Button type="submit" disabled={busy || !email || !password} className="w-full bg-gradient-to-b from-[#F0CB5C] to-[#C99E2E] text-black hover:from-[#D4AF37] hover:to-[#B8941F] font-brand font-extrabold uppercase tracking-wide py-6" data-testid="workforce-login-btn">
            {busy && <Loader2 size={16} className="animate-spin" />} Sign In
          </Button>
          <p className="text-[11px] text-gray-500 text-center">Forgot your login? Ask BuildBroz to send you a reset link.</p>
          <button type="button" onClick={() => navigate('/workforce')} className="w-full flex items-center justify-center gap-1.5 text-xs text-gray-400 hover:text-[#D4AF37] transition-colors" data-testid="back-to-portal-btn">
            <ArrowLeft size={13} /> Back to Workforce Portal
          </button>
        </form>
      </div>
    </WorkforceAuthPage>
  );
}
